<script setup>
import {humanFileSize} from '@/utils/file'

const props = defineProps({
    value: Number
})
</script>

<template>
    <span>{{ humanFileSize(value) }}</span>
</template>